import styled from 'styled-components';
import TextInputBase from '@sdk/components/forms/TextInputBase';

export const EditBillingInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 7px;
  margin-top: 20px;
`;

export const EditBillingInfoHeader = styled.div`
  align-items: center;
  display: flex;
  border-bottom: 1px solid ${(props) => props.theme.colors.separatorOnWhite};
  height: 40px;
  padding-bottom: 5px;
`;

export const BillingDetailsInput = styled(TextInputBase)`
  width: 100%;
`;
